export const PHYSICAL_CLINIC = {
    code: 'physical-clinic',
    text: 'Physical Clinic'
}
export const VIRTAUL_CLINIC = {
    code: 'virtual-clinic',
    text: 'Virtual Clinic'
}